module.exports = __webpack_public_path__ + "static/front-header-5d406502a226a7b01b5bf20c1ecc7fc6.jpg";